<template>
  <v-app>
    <!-- TOP SYSTEM BAR -->
    <v-app-bar
      flat
      :style="{
        background: themeStore.themeStyles.background,
        color: themeStore.themeStyles.color
      }"
      style="padding-left: 30px; padding-right: 30px;"
   
    >
      <!-- LEFT: Sidebar Controls -->
      <div class="d-flex align-center">
        <v-btn icon size="small" variant="text" @click="toggleSidebar">
          <v-icon>mdi-menu</v-icon>
        </v-btn>

        <v-btn icon size="small" variant="text" @click="togglePin">
          <v-icon :color="isPinned ? 'primary' : ''">mdi-pin</v-icon>
        </v-btn>
      </div>

       <!-- LOGO -->
      <router-link :to="{ name: 'PublicHome' }">
        <v-img
          v-if="getCurrentTheme === 'light'"
          :src="getLogoLight"
          style="width: 200px; height: 42px;"
        />
        <v-img
          v-else
          :src="getLogoDark"
          style="width: 200px; height: 42px;"
        />
      </router-link>
     

       <v-divider vertical class="mx-1"></v-divider>

        <div class="d-flex align-center">
          <MegaMenuSetup />
          <MegaMenu />
          <MegaMenuResources />
        </div>

        <v-spacer />

      <v-divider vertical class="mx-3"></v-divider>

      

      <!-- SETTINGS MENU -->
      <v-menu v-model="settingsMenu" :close-on-content-click="false">
        <template #activator="{ props }">
          <span
            v-bind="props"
            v-ripple
            class="icon-btn d-inline-flex align-center justify-center"
          >
            <v-icon size="large">mdi-theme-light-dark</v-icon>
          </span>
        </template>

        <v-card min-width="300">
          <v-list>
            <v-list-item
              prepend-avatar="https://cdn.vuetifyjs.com/images/john.jpg"
              subtitle="Founder of Vuetify"
              title="John Leider"
            >
              <template #append>
                <v-btn
                  icon="mdi-logout-variant"
                  variant="text"
                  @click="handleLogout"
                ></v-btn>
              </template>
            </v-list-item>
          </v-list>

          <v-divider></v-divider>

          <!-- THEME SWITCHES -->
          <v-row class="ma-2">
            <v-col cols="4" class="text-center">
              <v-switch
                v-model="lightSwitch"
                color="purple"
                hide-details
                @change="selectTheme('light')"
              />
              <div>Light</div>
            </v-col>

            <v-col cols="4" class="text-center">
              <v-switch
                v-model="darkSwitch"
                color="purple"
                hide-details
                @change="selectTheme('dark')"
              />
              <div>Dark</div>
            </v-col>

            <v-col cols="4" class="text-center">
              <v-switch
                v-model="hybridSwitch"
                color="purple"
                hide-details
                @change="selectTheme('hybrid')"
              />
              <div>Hybrid</div>
            </v-col>
          </v-row>

          <v-divider></v-divider>

          <v-list>
            <v-list-item>
              <v-switch
                v-model="message"
                color="purple"
                label="Enable messages"
                hide-details
              />
            </v-list-item>

            <v-list-item>
              <v-switch
                v-model="hints"
                color="purple"
                label="Enable hints"
                hide-details
              />
            </v-list-item>
          </v-list>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn variant="text" @click="toprightmenu = false">
              Cancel
            </v-btn>
            <v-btn color="primary" variant="text" @click="toprightmenu = false">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu> 

      <!-- Language Menu -->
          <v-menu v-model="toprightmenu1" offset-y>
            <template #activator="{ props }">
              <span
                v-bind="props"
                class="formatlang"
                style="
                  display: inline-flex;
                  align-items: center;
                  cursor: pointer;
                  gap: 2px;
                  margin-left: 10px;
                "
              >
                <v-tooltip activator="parent" location="bottom">
                  test
                </v-tooltip>
                <LanguageSwitcher @change="onLanguageChange" />
              </span>
            </template>
          </v-menu>

      

      <!-- LOGIN ICON -->
      <span class="icon-btn d-inline-flex align-center">
        <!-- <v-icon size="small">mdi-login</v-icon> -->
      </span>
    </v-app-bar>

    <!-- MAIN LAYOUT -->
    <v-layout style="margin-top: 80px;">

      <!-- ⭐ NEW: NAVIGATION DRAWER WRAPPING YOUR SIDEBAR ⭐ -->
      <v-navigation-drawer
        v-model="sidebarOpen"
        :permanent="isPinned"
        app
      >
        <FinanceSetupSidebar />
      </v-navigation-drawer>

      <!-- MAIN CONTENT -->
      <v-main>
        <router-view />
        <FinanceSetupFooter />
      </v-main>

    </v-layout>

  </v-app>
</template>

<script setup>
import { ref, computed, onMounted } from "vue"
import { useThemeStore, useAuthStore } from "@/store/auth"
import { useRouter } from "vue-router"
import FinanceSetupSidebar from "../components/FinanceSetupSidebar.vue"
import FinanceSetupFooter from "@/modules/financesetup/components/FinanceSetupFooter.vue"
import LanguageSwitcher from "@/components/LanguageSwitcher.vue"
import MegaMenu from "@/components/MegaMenu.vue"
import MegaMenuSetup from "@/components/MegaMenuSetup.vue"
import MegaMenuResources from "@/components/MegaMenuResources.vue"
import { useLangStore } from '@/store/lang';

import { useTenantStore } from "@/store/tenantStore.js"
const tenantStore = useTenantStore()

const themeStore = useThemeStore()
const auth = useAuthStore()
const router = useRouter()
const menu = ref(false)

const langStore = useLangStore()
const lang = computed(() => langStore.currentLanguage || "en")


const logoTarget = computed(() => {
  const lang = langStore.currentLang || "en";
  return auth.isLogin
    ? { name: "PublicHome", params: { lang: lang.value } }
    : { name: "PublicHome", params: { lang: lang.value } };
});


const sidebarOpen = ref(true)
const isPinned = ref(false)

const settingsMenu = ref(false)
const langMenu = ref(false)

const message = ref(false)
const hints = ref(false)

const lightSwitch = ref(false)
const darkSwitch = ref(false)
const hybridSwitch = ref(false)

function toggleSidebar() {
  if (!isPinned.value) {
    sidebarOpen.value = !sidebarOpen.value
  }
}

function togglePin() {
  isPinned.value = !isPinned.value
  if (isPinned.value) sidebarOpen.value = true
}

function selectTheme(theme) {
  lightSwitch.value = theme === "light"
  darkSwitch.value = theme === "dark"
  hybridSwitch.value = theme === "hybrid"
  themeStore.setTheme(theme)
}


function handleLogout() {
  auth.logout()
}

const getLogoLight = ref('')
const getLogoDark = ref('')
const getCurrentTheme = ref('')

onMounted(async () => {
  await tenantStore.loadTenant()
  getLogoLight.value = localStorage.getItem('LogoLight')
  getLogoDark.value = localStorage.getItem('LogoDark')
  getCurrentTheme.value = localStorage.getItem('currentTheme')
})
</script>
<style scoped>

.responsive-x-padding {
  padding-left: 10px;
  padding-right: 10px;
 
}

@media (min-width: 600px) { /* sm */
  .responsive-x-padding {
    padding-left: 10px;
    padding-right: 10px;
  }
}

@media (min-width: 960px) { /* md */
  .responsive-x-padding {
    padding-left: 100px;
    padding-right: 100px;
  }
}

@media (min-width: 1920px) { /* xl */
  .responsive-x-padding {
    padding-left: 300px;
    padding-right: 300px;
  }
}
</style>